import { render, staticRenderFns } from "./Saml.vue?vue&type=template&id=abb67ee0&scoped=true"
import script from "./Saml.vue?vue&type=script&lang=js"
export * from "./Saml.vue?vue&type=script&lang=js"
import style0 from "./Saml.vue?vue&type=style&index=0&id=abb67ee0&prod&lang=scss"
import style1 from "./Saml.vue?vue&type=style&index=1&id=abb67ee0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb67ee0",
  null
  
)

export default component.exports